// src/components/Login.js
import React, { useState } from "react";
import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isRegister) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("Usuario registrado:", userCredential.user);
      } else {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log("Usuario logueado:", userCredential.user);
      }
      setEmail("");
      setPassword("");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      console.log("Usuario Google:", result.user);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleAppleSignIn = () => {};

  return (
    <div className="flex flex-col gap-32 justify-center items-center min-h-screen bg-gray-100 px-4 sm:px-6 md:px-0">
      <h1 className="text-4xl font-bold">SubsZero</h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 sm:p-8 md:p-8 rounded-lg shadow-md w-full max-w-md flex flex-col gap-4"
      >
        <h2 className="text-2xl md:text-2xl font-bold mb-6 text-center">
          {isRegister ? "Registrar" : "Iniciar Sesión"}
        </h2>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <label className="block mb-2 font-semibold">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 mb-4 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="tu@email.com"
          required
        />

        <label className="block mb-2 font-semibold">Contraseña</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 mb-4 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="********"
          required
        />

        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600 duration-300"
        >
          {isRegister ? "Registrar" : "Iniciar Sesión"}
        </button>

        <div className="flex flex-col sm:flex-row gap-2 mt-2">
          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="w-full sm:w-1/2 bg-red-500 text-white p-2 rounded hover:bg-red-600 duration-300 flex justify-center items-center gap-2"
          >
            Iniciar con Google
          </button>
          <button
            type="button"
            onClick={handleAppleSignIn}
            className="w-full sm:w-1/2 bg-black text-white p-2 rounded hover:bg-gray-900 duration-300 flex justify-center items-center gap-2"
          >
            Iniciar con Apple
          </button>
        </div>

        <p
          className="text-center text-sm mt-4 text-gray-600 cursor-pointer hover:underline"
          onClick={() => setIsRegister(!isRegister)}
        >
          {isRegister
            ? "¿Ya tienes cuenta? Inicia sesión"
            : "¿No tienes cuenta? Regístrate"}
        </p>
      </form>
    </div>
  );
}
